// import React from "react";
// import {
//   Typography,
//   Card,
//   Table,
//   Tag,
//   Button,
//   message,
//   Popconfirm,
// } from "antd";
// // import { useGetAllWalletTransactionsQuery,
//         //  useApproveTransactionMutation ,} from "../../slices/paymentApiSlice";

//   import { useGetWalletTransactionQuery} from "../../slices/paymentApiSlice";       

// const { Title } = Typography;

// const AdminWalletHistoryPage = () => {
//   const { data, isLoading } = useGetWalletTransactionQuery();
//   console.log(data);
  
// //   const [approveTransaction] = useApproveTransactionMutation();

// //   const approveHandler = async (id) => {
// //     try {
// //       await approveTransaction(id).unwrap();
// //       message.success("Transaction Approved");
// //     } catch (err) {
// //       message.error("Failed to approve");
// //     }
// //   };

//   const columns = [
//     {
//       title: "User ID",
//       dataIndex: "userId",
//     },
//     {
//       title: "Type",
//       dataIndex: "type",
//       render: (type) =>
//         type === "credit" ? (
//           <Tag color="green">CREDIT</Tag>
//         ) : (
//           <Tag color="red">DEBIT</Tag>
//         ),
//     },
//     {
//       title: "Amount",
//       dataIndex: "amount",
//       render: (amount) => `₹ ${amount}`,
//     },
//     {
//       title: "Status",
//       dataIndex: "status",
//       render: (status) => {
//         if (status === "pending")
//           return <Tag color="orange">PENDING</Tag>;
//         if (status === "approved")
//           return <Tag color="green">APPROVED</Tag>;
//         return <Tag color="red">REJECTED</Tag>;
//       },
//     },
//     {
//       title: "Date",
//       dataIndex: "createdAt",
//       render: (date) => new Date(date).toLocaleString(),
//     },
//     {
//       title: "Action",
//       render: (_, record) =>
//         record.status === "pending" ? (
//           <Popconfirm
//             title="Approve this transaction?"
//             // onConfirm={() => approveHandler(record._id)}
//           >
//             <Button type="primary" size="small">
//               Approve
//             </Button>
//           </Popconfirm>
//         ) : (
//           "-"
//         ),
//     },
//   ];

//   return (
//     <>
//       <Title level={2}>Admin Wallet Transactions</Title>

//       <Card>
//         <Table
//           columns={columns}
//           dataSource={data?.data || []}
//           loading={isLoading}
//           rowKey="_id"
//         />
//       </Card>
//     </>
//   );
// };

// export default AdminWalletHistoryPage;





import React from "react";
import {
  Typography,
  Card,
  Table,
  Tag,
  Button,
  Popconfirm,
  Row,
  Col,
  Breadcrumb,message,
} from "antd";
import { MoneyCollectOutlined } from "@ant-design/icons";
import { useGetWalletTransactionQuery } from "../../slices/paymentApiSlice";
import { useApproveTransactionMutation } from "../../slices/adminApiSlice";

const { Title } = Typography;

const AdminWalletHistoryPage = () => {
  const { data, isLoading } = useGetWalletTransactionQuery();
  const [approveTransaction] = useApproveTransactionMutation();
console.log(data);

const approveHandler = async (id) => {
  try {
    await approveTransaction(id).unwrap();
    message.success("Transaction Approved Successfully");
  } catch (err) {
    message.error(err?.data?.error || "Approval failed");
  }
};
const columns = [
  {
    title: "User ID",
    dataIndex: "userId",
  },
  {
    title: "Holder Name",
    render: (_, record) =>
      record.bankDetails?.holderName || "-",
  },
  {
    title: "Account No",
    render: (_, record) =>
      record.bankDetails?.accountNumber
        ? "XXXXXX" + record.bankDetails.accountNumber.slice(-4)
        : "-",
  },
  {
    title: "IFSC",
    render: (_, record) =>
      record.bankDetails?.ifsc || "-",
  },
  {
    title: "Type",
    dataIndex: "type",
    render: (type) =>
      type === "credit" ? (
        <Tag color="green">CREDIT</Tag>
      ) : (
        <Tag color="red">DEBIT</Tag>
      ),
  },
  {
    title: "Amount",
    dataIndex: "amount",
    render: (amount) => `₹ ${amount}`,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (status) => {
      if (status === "pending")
        return <Tag color="orange">PENDING</Tag>;
      if (status === "approved")
        return <Tag color="green">APPROVED</Tag>;
      return <Tag color="red">REJECTED</Tag>;
    },
  },
  {
    title: "Date",
    dataIndex: "createdAt",
    render: (date) => new Date(date).toLocaleString(),
  },
  {
    title: "Action",
    render: (_, record) =>
      record.status === "pending" ? (
        <Popconfirm
          title="Approve this transaction?"
          onConfirm={() => approveHandler(record._id)}
        >
          <Button type="primary" size="small">
            Approve
          </Button>
        </Popconfirm>
      ) : (
        "-"
      ),
  },
];
  return (
    <div>
      {/* Page Title */}
      <Title
        level={2}
        style={{
          fontFamily: "Inter, sans-serif",
          marginBottom: "16px",
        }}
      >
        <MoneyCollectOutlined /> &nbsp; Wallet Transactions
      </Title>

      {/* Breadcrumb Section */}
      <Row
        style={{
          padding: "20px",
          backgroundColor: "#FFF",
          borderRadius: "5px",
          marginBottom: "20px",
        }}
      >
        <Col flex="auto">
          <Breadcrumb
            items={[
              { title: "Payment" },
              { title: "Wallet Transactions" },
            ]}
          />
        </Col>
      </Row>

      {/* Table Section */}
      <Card title="All Wallet Transactions" loading={isLoading}>
        <Table
          columns={columns}
          dataSource={data?.data || []}
          rowKey={(record) => record._id}
          pagination={{ pageSize: 10 }}
          size="small"
          style={{ width: "100%" }}
          scroll={{ x: "max-content" }}
        />
      </Card>
    </div>
  );
};

export default AdminWalletHistoryPage;